/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ConditionType {
  ConditionGroup = 'ConditionGroup',
  AlwaysTrueCondition = 'AlwaysTrueCondition',
  AnyTagExistsCondition = 'AnyTagExistsCondition',
  AllTagsNotExistCondition = 'AllTagsNotExistCondition',
  ContainsAllStringsCondition = 'ContainsAllStringsCondition',
  ContainsAllStringsNearbyCondition = 'ContainsAllStringsNearbyCondition',
  ContainsAnyStringCondition = 'ContainsAnyStringCondition',
  StartsWithAnyStringCondition = 'StartsWithAnyStringCondition',
  StringEqualsCondition = 'StringEqualsCondition',
  GreaterThanOrEqualDateTimeCondition = 'GreaterThanOrEqualDateTimeCondition',
  LessThanOrEqualDateTimeCondition = 'LessThanOrEqualDateTimeCondition',
  FixedRangeDateTimeCondition = 'FixedRangeDateTimeCondition',
  FutureDateTimeCondition = 'FutureDateTimeCondition',
  PastDateTimeCondition = 'PastDateTimeCondition',
  SelectionContainsAllIdsCondition = 'SelectionContainsAllIdsCondition',
  SelectionContainsAnyIdCondition = 'SelectionContainsAnyIdCondition',
  SelectionEqualsCondition = 'SelectionEqualsCondition',
  DocumentIsStampedCondition = 'DocumentIsStampedCondition',
  DocumentAssignedToMagnetCondition = 'DocumentAssignedToMagnetCondition',
  ComparingLongCondition = 'ComparingLongCondition',
  FixedRangeLongCondition = 'FixedRangeLongCondition',
  AnyTagIsEmptyCondition = 'AnyTagIsEmptyCondition',
  AnyTagIsNotEmptyCondition = 'AnyTagIsNotEmptyCondition'
}
